function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.506 4.483s8.14-2.554 19.012-2.65c7.005-.06 15.043 1.999 34.371 2.184 10.344.099 25.906-1.298 38.167-1.405 7.898-.07 22.562 2.886 37.451 2.756 6.404-.056 15.665-2.384 25.769-2.472 8.125-.07 16.241 2.106 16.241 2.106",
  stroke: "#F5D176",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgUnderlineYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc1IiBoZWlnaHQ9IjciIHZpZXdCb3g9IjAgMCAxNzUgNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNTA2MDQgNC40ODI2OUMxLjUwNjA0IDQuNDgyNjkgOS42NDUzMSAxLjkyODc4IDIwLjUxNzcgMS44MzM5QzI3LjUyMyAxLjc3Mjc2IDM1LjU2MSAzLjgzMTUgNTQuODg5NCA0LjAxNjgyQzY1LjIzMzQgNC4xMTU5OSA4MC43OTUyIDIuNzE4NzkgOTMuMDU2MSAyLjYxMTc5QzEwMC45NTQgMi41NDI4NiAxMTUuNjE4IDUuNDk4MjkgMTMwLjUwNyA1LjM2ODM2QzEzNi45MTEgNS4zMTI0NyAxNDYuMTcyIDIuOTg0NDkgMTU2LjI3NiAyLjg5NjMxQzE2NC40MDEgMi44MjU0MSAxNzIuNTE3IDUuMDAxNzQgMTcyLjUxNyA1LjAwMTc0IiBzdHJva2U9IiNGNUQxNzYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgUnderlineYellow as ReactComponent };